import { makeStyles } from '@material-ui/styles';
import { COLORS } from '../../../styles/color.styles';

export const customButtonStyles = makeStyles({
	xl: {
		width: '250px !important',
	},
	primary: {
		fontSize: 14,
		fontWeight: 700,
		textTransform: 'none',
		color: '#FAFAFA',
		backgroundColor: COLORS.primary,
		height: 40,
		width: 188,
		borderRadius: '200px',
		padding: '10px 23px',

		'&:hover': {
			backgroundColor: COLORS.primaryHover,
		},

		'&:focus': {
			boxShadow: '0 0 0 2pt #e0e0e0',
		},
		'&:active': {
			fontSize: 14,
			textTransform: 'none',
			color: '#ffffff',
			backgroundColor: COLORS.primaryPress,
		},
		'&:disabled': {
			backgroundColor: COLORS.primaryDisabled,
			color: '#ffffff',
		},
	},
	secondary: {
		fontSize: 14,
		fontWeight: 700,
		textTransform: 'none',
		color: COLORS.primary,
		backgroundColor: '#FAFAFA',
		height: 40,
		width: 200,
		borderRadius: '200px',
		padding: '10px 20px',
		margin: '0 auto',
		border: '2px solid #CFCFCF',
		boxShadow: 'none',
		'&:hover': {
			backgroundColor: '#CFCFCF',
		},

		'&:focus': {
			border: `2px solid ${COLORS.primary}`,
		},
	},
});
